import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { SkuDistrictParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { DateRange } from '@project-types/DateRange';



export const selectGridData = (state: RootState) => state.reportingDeliveriesSkuDistrict.gridData;
export const selectDateRange = (state: RootState) => state.reportingDeliveriesSkuDistrict.dateRange;
export const selectMaterialId = (state: RootState) => state.reportingDeliveriesSkuDistrict.materialId;



export const selectParamMaterialId = createSelector(selectMaterialId, materialId => {
	if (!materialId || materialId.length === 0) return null;
	if (materialId.length < 4) return null;
	return materialId;
});


export const selectValidParams = createSelector(
	[
		selectDateRange,
		selectParamMaterialId,
	],(
		dateRange: DateRange | null,
		materialId: string | null,
	) => {
		if (!dateRange || !materialId) return null;
		let validParams: SkuDistrictParams = {
			dateFrom: dateRange.from,
			dateTo: dateRange.to,
			materialId,
		};
		return validParams;
	}
);